export default __webpack_public_path__ + "static/media/arvindLogo.fade6076.png";